<section class="stepper-body">
    @if (!hideHeader) {
        <header class="stepper-navigation-bar">
            @for (step of steps; track step; let i = $index; let isLast = $last) {
                <!-- S2N-1420: a step in disableSpecificStepClicks already swallows the click; it
                     now also looks unavailable, so it stops inviting one. -->
                <button
                    class="step"
                    [disabled]="disableSpecificStepClicks.includes(i)"
                    (click)="manualClick(i)"
                >
                    {{ step.label }}
                    <div 
                        class="stepper-number" 
                        [ngClass]="{ 'stepper-active': selectedIndex > i - 1 }"
                    >
                        <span class="center-number">{{ i + 1 }}</span>
                    </div>
                </button>		
            }
        </header>
    }
	
	<div class="content-container">
		@for (step of steps; track step; let i = $index) {
            <div
                class="stepper-content"		
                [style.display]="stepDisplay[i]"
                [@stepTransition]="_getAnimationDirection(i)"
                (@stepTransition.done)="_animationDone.next($event)"
                [attr.tabindex]="selectedIndex === i ? 0 : null"
                [id]="_getStepContentId(i)"
                [attr.aria-labelledby]="_getStepLabelId(i)"
                [attr.aria-expanded]="selectedIndex === i"
            >
                @if (
                    selectedIndex === i 
                    || !destroyOnHide
                ) { <ng-container [ngTemplateOutlet]="step.content"> </ng-container> }
            </div>
        }
	</div>
</section>
